export const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1300,
    backgroundColor: 'surface.overlay',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialog: {
    backgroundColor: 'background.paper',
    borderRadius: 3,
    padding: 6,
    maxWidth: 480,
    textAlign: 'center',
    boxShadow: '0 16px 48px rgba(0,0,0,0.24)',
  },
  titleSpacing: {
    marginBottom: 1,
  },
  bodySpacing: {
    marginBottom: 4,
  },
  buttonRow: {
    display: 'flex',
    gap: 2,
    justifyContent: 'center',
  },
}
